import React, { JSX, useState } from 'react';
import styles from './tooltip.module.css';

interface TooltipProps {
  text: string;
  children: React.ReactNode;
  marginTop?: string;
}

export function Tooltip({ text, children, marginTop }: TooltipProps): JSX.Element {
  const [visible, setVisible] = useState(false);

  return (
    <div
      className={styles['tooltip-container']}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      style={{
        marginTop,
      }}
    >
      {children}
      {visible && <div className={styles['tooltip-content']}>{text}</div>}
    </div>
  );
}
